import React, { PropsWithChildren } from 'react';

import { SidebarProvider, TooltipProvider } from '@surface/components';

type ContextProps = {
  topBarLeftComponent?: [
    Element | null,
    React.Dispatch<React.SetStateAction<Element | null>>,
  ];
  topBarRightComponent?: [
    Element | null,
    React.Dispatch<React.SetStateAction<Element | null>>,
  ];
  secondaryPanelComponent?: [
    Element | null,
    React.Dispatch<React.SetStateAction<Element | null>>,
  ];
  secondaryPanelWidth?: [number, React.Dispatch<React.SetStateAction<number>>];
  secondaryPanelHasContent?: [
    boolean,
    React.Dispatch<React.SetStateAction<boolean>>,
  ];
  secondaryPanelResizable?: [
    boolean,
    React.Dispatch<React.SetStateAction<boolean>>,
  ];
};

export const LayoutContext = React.createContext<ContextProps>({});

export const LayoutProvider = (props: PropsWithChildren) => {
  const topBarLeftComponent = React.useState<Element | null>(null);
  const topBarRightComponent = React.useState<Element | null>(null);
  const secondaryPanelComponent = React.useState<Element | null>(null);
  const secondaryPanelWidth = React.useState<number>(40);
  const secondaryPanelHasContent = React.useState<boolean>(false);
  const secondaryPanelResizable = React.useState<boolean>(true);

  return (
    <LayoutContext.Provider
      value={React.useMemo(
        () => ({
          topBarLeftComponent,
          topBarRightComponent,
          secondaryPanelComponent,
          secondaryPanelWidth,
          secondaryPanelHasContent,
          secondaryPanelResizable,
        }),
        [
          topBarLeftComponent,
          topBarRightComponent,
          secondaryPanelComponent,
          secondaryPanelWidth,
          secondaryPanelHasContent,
          secondaryPanelResizable,
        ]
      )}
    >
      <TooltipProvider>
        <SidebarProvider>
          <div className="flex w-full justify-center min-h-screen max-h-full relative">
            {props.children}
          </div>
        </SidebarProvider>
      </TooltipProvider>
    </LayoutContext.Provider>
  );
};
